import { Flex, Spacer } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { UserRead } from "@nens/rana/api-v1";
import { ButtonWrapper, RanaButton, RanaLoading } from "@nens/ranalib";

import { AdminForm } from "@/features/admin";

import {
  AdminTenantUserEdit,
  useAdminTenantUserDetail,
  useTenantUserFormSchema,
} from "../hooks/use-admin-tenant-user-detail";

import { AdminTenantUserDeleteModal } from "./admin-tenant-user-delete-modal";

export function AdminTenantUserDetail({ user }: { user: UserRead }) {
  const { schema, uiSchema, isLoading } = useTenantUserFormSchema();
  const adminTenantUserDetailHook = useAdminTenantUserDetail(user);
  if (isLoading || adminTenantUserDetailHook?.isLoading)
    return <RanaLoading isCentered size="xl" />;

  const { formData, onSubmit, tenantList, setDeleteModalOpen, isDeleteModalOpen } =
    adminTenantUserDetailHook;

  return (
    <>
      {isDeleteModalOpen && (
        <AdminTenantUserDeleteModal
          user={user}
          tenants={tenantList}
          onClose={() => setDeleteModalOpen(false)}
        />
      )}

      <AdminForm
        schema={schema}
        formData={formData}
        uiSchema={uiSchema}
        onSubmit={async (t) => {
          const newUserInfo = t.formData as AdminTenantUserEdit;
          onSubmit(newUserInfo);
        }}
      >
        <Flex mt={11} justifyContent="space-between">
          <RanaButton onClick={() => setDeleteModalOpen(true)} variant="danger">
            <FormattedMessage id="button.delete_user" defaultMessage="Delete User" />
          </RanaButton>
          <Spacer />
          <ButtonWrapper>
            <RanaButton ml="auto" type="submit" variant="primary">
              <FormattedMessage id="button.save_changes" defaultMessage="Save Changes" />
            </RanaButton>
          </ButtonWrapper>
        </Flex>
      </AdminForm>
    </>
  );
}
